import {
  apiGetStudent,
  apiUpdateStudent,
  apiResetStudentPasscode,
  apiAddStudentToAGroup,
  apiRemoveStudentFromGroup,
  apiAddPermissionToStudent,
  apiRemovePermissionFromStudent
} from '../../common/api/student-management'

import { getGroups } from '../groups/groups.selectors'

const defaultInclude =
  'account.names,account.avatar,account.student_type.dob,account.student_type.year_group,account.student_type.year_group.names,account.student_type.year_group.order,account.student_type.passcode,account.student_type.groups,account.student_type.group.policy.can_update,account.student_type.group.names,account.student_type.group.mis,account.student_type.parent_types,account.student_type.parent_type.account,account.student_type.parent_type.status,account.student_type.parent_type.account.email_identity.email,account.student_type.policy,account.student_type.parent_type.policy,account.student_type.parent_code,account.student_type.parent_types,account.student_type.parent_type.account,account.student_type.parent_type.account.names'

const fetchProfile = id => ({
  requestPrefix: 'PUPIL_PROFILE_STORE:FETCHING',
  params: { id },
  request: () =>
    apiGetStudent(id, {
      include: defaultInclude
    })
})

const updatePupil = (id, data) => ({
  requestPrefix: 'PUPIL_PROFILE_STORE:UPDATE_PUPIL',
  params: { id },
  request: () =>
    apiUpdateStudent(id, data, {
      include: defaultInclude
    })
})

const resetPasscode = id => ({
  requestPrefix: 'PUPIL_PROFILE_STORE:RESET_PASSCODE',
  params: { id },
  request: () =>
    apiResetStudentPasscode(id, {
      include: defaultInclude
    })
})

const addPupilToGroup = (id, data) => (dispatch, getState) =>
  dispatch({
    requestPrefix: 'PUPIL_PROFILE_STORE:ADD_PUPIL_TO_GROUP',
    params: { id, groups: getGroups(getState()) },
    request: () =>
      apiAddStudentToAGroup(data, {
        include: 'group.policy,group.mis,group.names'
      })
  })

const removePupilFromGroup = data => ({
  requestPrefix: 'PUPIL_PROFILE_STORE:REMOVE_PUPIL_FROM_GROUP',
  params: { id: data.student_account_id, groupId: data.group_id },
  request: () => apiRemoveStudentFromGroup(data)
})

const refetchPolicy = id => ({
  requestPrefix: 'PUPIL_PROFILE_STORE:REFETCH_POLICY',
  params: { id },
  request: () =>
    apiGetStudent(id, {
      include: 'account.student_type.policy'
    })
})

const addPermissionProfile = id => ({
  requestPrefix: 'PUPIL_PROFILE_STORE:ADD_PERMISSION',
  params: { id },
  request: () => apiAddPermissionToStudent(id)
})

const removePermissionProfile = id => ({
  requestPrefix: 'PUPIL_PROFILE_STORE:REMOVE_PERMISSION',
  params: { id },
  request: () => apiRemovePermissionFromStudent(id)
})

export {
  fetchProfile,
  updatePupil,
  resetPasscode,
  addPupilToGroup,
  removePupilFromGroup,
  refetchPolicy,
  addPermissionProfile,
  removePermissionProfile
}
